class NewsItem{
    constructor(id,title,text,img,cat_news,created_at,date){
        this.id=id;
        this.title=title;
        this.img=img;
        this.cat_news=cat_news;
        this.text=text;
        this.date=date;
        this.created_at=created_at;
    }
    setData(json){
        this.id=json.id;
        this.title=json.title;
        this.img=json.img;
        this.cat_news=json.cat_news;
        this.text=json.text;
        this.date=json.date;
        this.created_at=json.created_at;
    }
}

export default NewsItem;